import { render } from "./TokenRowSkeleton.vue?vue&type=template&id=f83547da&scoped=true"
const script = {}

import "./TokenRowSkeleton.vue?vue&type=style&index=0&id=f83547da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83547da"]])

export default __exports__